const colors = ["#ab47bc", "#29b6f6", "#ffa726", "#9ccc65", "#7e57c2"];

export default colors;
